import React from 'react';

// Material ui
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';

// Styles
import useStyles from './styles';

interface ReportTitleInterface {
  title: string;
  titleVariant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  infoIconColor?: string;
  infoIconBgColor?: string;
  tooltipTitle: string;
  classStyle?: string;
  compactInfoIcon?: boolean;
  spaceBetween?: boolean;
}

const ReportTitle: React.FC<ReportTitleInterface> = ({
  title,
  titleVariant = 'h4',
  infoIconColor,
  infoIconBgColor,
  tooltipTitle,
  classStyle,
  compactInfoIcon = false,
  spaceBetween = false,
}) => {
  const classes = useStyles();
  const infoIconSize = compactInfoIcon ? '1.15rem' : '1.5rem';
  const infoIconPaddingTop = compactInfoIcon ? '0.05rem' : '0.25rem';
  const infoIconTextSize = compactInfoIcon ? '0.8rem' : '1rem';
  const infoIconMarginLeft = compactInfoIcon ? '0.4rem' : '0.25rem';

  return (
    <Box
      width='100%'
      display='flex'
      alignItems='center'
      justifyContent={spaceBetween ? 'space-between' : 'flex-start'}>
      <Typography
        className={classStyle ? classStyle : classes.default}
        style={
          spaceBetween
            ? {
                flex: 1,
                marginRight: infoIconMarginLeft,
                minWidth: 0,
              }
            : undefined
        }
        variant={titleVariant}>
        {title}
      </Typography>
      <Tooltip title={tooltipTitle} placement='top'>
        <Box
          display='flex'
          alignItems='center'
          justifyContent='center'
          width={infoIconSize}
          height={infoIconSize}
          bgcolor={infoIconBgColor ? infoIconBgColor : '#000'}
          borderRadius='50%'
          flexShrink={0}
          ml={spaceBetween ? 0 : infoIconMarginLeft}
          pt={infoIconPaddingTop}>
          <Typography
            style={{
              color: infoIconColor ? infoIconColor : '#fff',
              fontSize: infoIconTextSize,
            }}>
            i
          </Typography>
        </Box>
      </Tooltip>
    </Box>
  );
};

export default ReportTitle;
export { ReportTitle };
